function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "5r0r0iwoba",
  cx: "170%",
  cy: "15%",
  r: "947.934%",
  fx: "170%",
  fy: "15%",
  gradientTransform: "matrix(.365 0 0 1 1.08 0)"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#4387FD"
}), React.createElement("stop", {
  offset: "65%",
  stopColor: "#3078F0"
}), React.createElement("stop", {
  offset: "91%",
  stopColor: "#2B72EA"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#286EE6"
})), React.createElement("radialGradient", {
  id: "x92ium6ykb",
  cx: "186%",
  cy: "108%",
  r: "375.989%",
  fx: "186%",
  fy: "108%",
  gradientTransform: "matrix(.8378 0 0 1 .302 0)"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFD24D"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#F6C338"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-40 -7378) translate(-246 7268) translate(286 110)"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 13,
  fill: "#BFC0C2",
  stroke: "#F9F9F9",
  strokeWidth: 14
}), React.createElement("g", null, React.createElement("path", {
  fill: "#757575",
  fillRule: "nonzero",
  d: "M42.853 7.485c2.303 0 4.039.757 5.399 2.176 1.398 1.401 1.831 3.369 1.831 4.958 0 .492-.038.946-.113 1.324h-7.117v-2.12h5.06c-.153-1.193-.548-2.062-1.152-2.668-.738-.739-1.888-1.552-3.908-1.552-3.115 0-5.55 2.517-5.55 5.64 0 3.123 2.435 5.639 5.55 5.639 1.68 0 2.908-.662 3.813-1.514l1.491 1.495C46.892 22.073 45.212 23 42.853 23 38.586 23 35 19.519 35 15.242c0-4.275 3.586-7.757 7.853-7.757zm43.065.303V22.47h-2.19V7.788h2.19zm38.754 11.157c.34 0 .63.12.869.36.239.239.358.53.358.87 0 .34-.12.63-.358.87-.24.24-.529.36-.869.36-.34 0-.629-.12-.868-.36-.24-.24-.359-.53-.359-.87 0-.34.12-.631.359-.87.239-.24.528-.36.868-.36zm-16.646-11.24c2.076 0 3.737.628 4.983 1.883 1.246 1.255 1.869 2.886 1.869 4.891 0 2.006-.623 3.636-1.87 4.891-1.245 1.256-2.906 1.883-4.982 1.883h-4.134V7.706zm0 1.666h-2.398v10.217h2.398c1.56 0 2.796-.45 3.709-1.353.912-.902 1.368-2.154 1.368-3.756 0-1.614-.456-2.87-1.368-3.765-.913-.895-2.149-1.343-3.71-1.343zM55.834 7.486c2.757 0 5.002 2.12 5.002 4.995 0 2.894-2.245 4.995-5.002 4.995-2.756 0-5.002-2.1-5.002-4.995 0-2.876 2.246-4.995 5.002-4.995zm10.913 0c2.756 0 5.002 2.12 5.002 4.995 0 2.894-2.246 4.995-5.002 4.995s-5.002-2.1-5.002-4.995c0-2.876 2.246-4.995 5.002-4.995zM77.48 3c2.567 0 4.738 1.514 4.738 5.203v8.97h-2.076v-.813h-.076c-.49.587-1.434 1.116-2.623 1.116-2.492 0-4.777-2.195-4.777-5.014 0-2.801 2.285-4.977 4.777-4.977 1.189 0 2.132.53 2.623 1.135h.076v-.718c0-1.912-1.02-2.933-2.662-2.933-1.34 0-2.17.965-2.51 1.778l-1.907-.795C73.61 4.628 75.064 3 77.48 3zm14.443 4.485c2.284 0 3.605 1.4 4.153 2.214l-1.7 1.135c-.567-.832-1.341-1.382-2.455-1.382-1.113 0-1.906.512-2.415 1.514l6.664 2.763-.227.567c-.416 1.116-1.68 3.179-4.266 3.179-2.568 0-4.7-2.026-4.7-4.995 0-2.8 2.115-4.995 4.946-4.995zm49.735-.082c1.007 0 1.857.243 2.549.728.692.486 1.189 1.088 1.491 1.807l-1.548.644c-.44-1.06-1.283-1.59-2.53-1.59-.767 0-1.437.272-2.01.814-.572.542-.884 1.28-.934 2.214h7.305l.019.321c0 1.501-.412 2.7-1.236 3.595-.825.896-1.923 1.344-3.294 1.344-1.322 0-2.407-.486-3.256-1.457-.85-.971-1.275-2.132-1.275-3.482 0-1.425.438-2.604 1.312-3.538.875-.933 2.01-1.4 3.407-1.4zm-23.393.303v5.07c0 .808.242 1.46.727 1.959.484.498 1.04.747 1.67.747.39 0 .698-.044.925-.132l.66 1.627c-.352.151-.786.227-1.302.227s-1.047-.164-1.595-.492c-.547-.328-.909-.744-1.085-1.249h-.076v1.514h-1.66V7.706h1.736zm14.306 0l3.775 9.271h-1.85l-2.756-7.19h-.038l-2.718 7.19h-1.887l3.737-9.271h1.737zm-7.03 0v9.271h-1.737V7.706h1.737zm18.61 5.752h-5.362c.177.68.5 1.223.972 1.627.472.404 1.03.605 1.671.605.88 0 1.545-.24 1.991-.719.447-.479.69-.983.727-1.513zm-55.006-.826c-.056 1.93 1.492 2.913 2.605 2.913.869 0 1.605-.434 1.85-1.06l-4.455-1.853zm-33.31-3.18c-1.51 0-2.813 1.25-2.813 3.028 0 1.797 1.302 3.027 2.812 3.027 1.51 0 2.813-1.23 2.813-3.027 0-1.779-1.303-3.028-2.813-3.028zm10.912 0c-1.51 0-2.812 1.25-2.812 3.028 0 1.797 1.302 3.027 2.812 3.027 1.51 0 2.812-1.23 2.812-3.027 0-1.779-1.302-3.028-2.812-3.028zm10.885 0c-1.51 0-2.776 1.269-2.776 3.008 0 1.76 1.266 3.047 2.776 3.047 1.49 0 2.662-1.286 2.662-3.047-.002-1.74-1.171-3.008-2.662-3.008z",
  transform: "translate(57 7) matrix(1 0 0 -1 0 26)"
}), React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#0DA960",
  d: "M4.6 22.311L0.115 14.546 8.509 0 12.993 7.764z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
}), React.createElement("path", {
  fill: "url(#5r0r0iwoba)",
  d: "M4.599 22.311L9.083 14.546 25.871 14.546 21.386 22.311z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
}), React.createElement("path", {
  fill: "url(#x92ium6ykb)",
  d: "M25.872 14.546L16.903 14.546 8.509 0 17.477 0z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
}), React.createElement("path", {
  fill: "#2D6FDD",
  d: "M12.993 14.546L9.083 14.546 11.029 11.155 4.599 22.31z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
}), React.createElement("path", {
  fill: "#E5B93C",
  d: "M16.904 14.546L25.872 14.546 14.958 11.155z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
}), React.createElement("path", {
  fill: "#0C9B57",
  d: "M11.029 11.155L12.994 7.764 8.509 0z",
  transform: "translate(57 7) translate(.065 .22) translate(.384 .384)"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#0DA960",
  d: "M4.6 22.311L0.115 14.546 8.509 0 12.993 7.764z",
  transform: "translate(57 7) translate(.065 .22)"
}), React.createElement("path", {
  fill: "url(#5r0r0iwoba)",
  d: "M4.599 22.311L9.083 14.546 25.871 14.546 21.386 22.311z",
  transform: "translate(57 7) translate(.065 .22)"
}), React.createElement("path", {
  fill: "url(#x92ium6ykb)",
  d: "M25.872 14.546L16.903 14.546 8.509 0 17.477 0z",
  transform: "translate(57 7) translate(.065 .22)"
}), React.createElement("path", {
  fill: "#2D6FDD",
  d: "M12.993 14.546L9.083 14.546 11.029 11.155 4.599 22.31z",
  transform: "translate(57 7) translate(.065 .22)"
}), React.createElement("path", {
  fill: "#E5B93C",
  d: "M16.904 14.546L25.872 14.546 14.958 11.155z",
  transform: "translate(57 7) translate(.065 .22)"
}), React.createElement("path", {
  fill: "#0C9B57",
  d: "M11.029 11.155L12.994 7.764 8.509 0z",
  transform: "translate(57 7) translate(.065 .22)"
})))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 203,
    height: 40,
    viewBox: "0 0 203 40"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/integration-google-drive.949ffccd.svg";
export { SvgComponent as ReactComponent };